import React, { useState, useEffect } from "react";
import "./FAQ.css";
import FeedbackIcn from "../assets/images/feedback-icn.png";
import ClarityIcn from "../assets/images/clarity-icn.png";
import HandsIcn from "../assets/images/hands-icn.png";
import StrongerIcn from "../assets/images/stronger-icn.png";
import cert1 from '../assets/images/coi01.png';
import cert2 from '../assets/images/coi02.png';
import cert3 from '../assets/images/coi03.png';
import ColorImg from '../assets/images/color-img.png';

import Form from "./Form";

const CertificateSlider = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const certificates = [
    {
      id: 1,
      leftBg: 'linear-gradient(135deg, #5B9BD5 0%, #4A8BC2 100%)',
      title: 'CERTIFICATE01',
      subtitle: 'OF TRAINING',
      bgImage: cert1
    },
    {
      id: 2,
      leftBg: 'linear-gradient(135deg, #6B7A8F 0%, #5A6875 100%)',
      title: 'CERTIFICATE',
      subtitle: 'OF TRAINING',
      bgImage: cert2
    },
    {
      id: 3,
      leftBg: 'linear-gradient(135deg, #4CAF50 0%, #45A049 100%)',
      title: 'CERTIFICATE',
      subtitle: 'OF TRAINING',
      bgImage: cert3
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev - 1 + certificates.length) % certificates.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [certificates.length]);

  const handleClick = (index) => {
    setActiveIndex(index);
  };

  return (
    <div style={{ 
      position: 'relative', 
      width: '100%', 
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      {certificates.map((cert, index) => {
        let position = index - activeIndex;
        
        if (position < -1) position += certificates.length;
        if (position > 1) position -= certificates.length;
        
        const absPosition = Math.abs(position);
        let offset = position * 50;
        
        let heightIncrease = 0;
        
        if (position === -1) {
          offset = position * 50 - 20;
          heightIncrease = 30;
        } else if (position === 1) {
          offset = position * 50 + 20;
          heightIncrease = 30;
        }
        
        const scale = 1 - absPosition * 0.04;
        const zIndex = certificates.length - absPosition;
        const opacity = absPosition > 1 ? 0 : 1 - absPosition * 0.25;

        return (
          <div
            key={cert.id}
            onClick={() => handleClick(index)}
            style={{
              position: 'absolute',
              width: '100%',
              maxWidth: '100%',
              cursor: 'pointer',
              transition: 'all 0.7s ease-out',
              transform: `translateY(${offset}px) scale(${scale})`,
              zIndex: zIndex,
              opacity: opacity,
            }}
          >
            <div style={{ 
              boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
              display: 'flex',
              overflow: 'hidden',
              height: `${290 + heightIncrease}px`,
              borderRadius: '8px',
              backgroundImage: `url(${cert.bgImage})`,
              backgroundSize: '100% 100%',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat'
            }}>
            </div>
          </div>
        );
      })}
   </div>
  );
};

const FAQ = () => {
  // ❌ Remove these - Form component handles its own state now
  // const [formData, setFormData] = useState({...});
  // const [allData, setAllData] = useState([]);
  // const handleChange = (e) => {...};
  // const handleSubmit = async (e) => {...};

  return (
    <div className="robot-container" id="form-faq-id">
      <div className="fdfdfdfd">
        <div className="roi-section">
          <div className="robot-top-section">
            <h2 className="roi-title">
              What is your <span className="roi-highlight">ROI?</span>
            </h2>
            <div className="roi-content">
             <div className="roi-content-bar">
              <div className="roi-grid">
                <div className="roi-item roi-top-left">
                  <div className="roi-icon">
                    <img src={FeedbackIcn} className="feedback-icn" alt="Feedback" />
                  </div>
                  <p className="roi-text">
                    <span className="roi-highlight-text">Personalized feedback <br />and guidance</span>
                  </p>
                </div>

                <div className="roi-item roi-top-right">
                  <div className="roi-icon">
                    <img src={ClarityIcn} className="feedback-icn" alt="Clarity" />
                  </div>
                  <p className="roi-text">
                    <span className="roi-highlight-text">Clarity on career<br /> Opportunities</span>
                  </p>
                </div>

                <div className="roi-robot">
                  <div className="robot-image">
                    <div className="spline-robo"> 
                      <spline-viewer url="https://prod.spline.design/h7jwrnn95onr-95A/scene.splinecode" className="model"></spline-viewer>
                    </div> 
                  </div>
                </div>

                <div className="roi-item roi-bottom-left">
                  <div className="roi-icon">
                    <img src={HandsIcn} className="feedback-icn" alt="Hands-on" />
                  </div>
                  <p className="roi-text">
                    <span className="roi-highlight-text">Hands-on learning with <br />real-world projects</span>
                  </p>
                </div>

                <div className="roi-item roi-bottom-right">
                  <div className="roi-icon">
                    <img src={StrongerIcn} className="feedback-icn" alt="Communication" />
                  </div>
                  <p className="roi-text">
                    <span className="roi-highlight-text">Stronger communication<br /> & collaboration</span>
                  </p>
                </div>
              </div>
              <div className="roi-robot mobile-robot">
                  <div className="robot-image">
                    <div className="spline-robo"> 
                      <spline-viewer url="https://prod.spline.design/h7jwrnn95onr-95A/scene.splinecode" className="model"></spline-viewer>
                    </div> 
                  </div>
              </div>
              </div> 
            </div>
          </div>       
        </div>
      </div>
      <div id="ask-id" className="ask-section">
        <div className="roi-content">
          <div className="ask-title-bar">
            <div className="ask-title-text">
              Before you<span>ask</span>
              <p className="ask-title-p">
                Yes! You will be certified for this program
              </p>      
            </div>
          </div>
          <div className="overview-content01">
            <div className="slider-vertical">
              <CertificateSlider />
            </div> 
            <div className="professional-bar">
             <div className="professional-text">
               <span className="ahead-text">Get Ahead</span> 
               <div className="intro-text">Introducing our <b>RoboAI</b> masterclass for all working professionals.</div>
               <div className="btn-enroll"><a href="https://pages.razorpay.com/ROBOAI-I90" target="_blank" rel="noopener noreferrer">Enroll Now</a></div>
               <div className="color-img"><img src={ColorImg} className="color-image" alt="Color" /></div>
               <div className="alre-text"><b>60000+</b> Mentees<br /> Enrolled Already!</div>
             </div>  
            <div className="overview-form">
              {/* ✅ Form component now handles everything independently */}
              <Form /> 
            </div>
            </div> 
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;